<script lang="ts" setup>
import GiftASticker from '@/views/manage-content/media/stickers/GiftASticker.vue';
import { computed, onMounted, reactive, ref, watch } from 'vue';
import shared from '@/views/manage-content/media/shared';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import StickerInsights from '@/views/manage-content/media/stickers/StickerInsights.vue';

const route = useRoute();
const store = useStore();
const loading = ref(false);
const { findStickerInsights, getWinners } = shared();

const item = computed(() => store.getters['sticker/GET_STICKER']);

const stickerId = computed(() => (
  (route.params.id as string | undefined) || item.value?.id || null
));

const stickerInsights = reactive({});
const winners = ref<Winner[]>([]);

interface Winner {
  id: string;
  stickerId: string;
  entityId: string;
  participantName: string;
  participantAvatar: string;
  participantEmail: string;
  eligible: boolean;
  dateCreated: string;
  dateUpdated: string;
}

async function getStickerInsights() {
  if (!stickerId.value) {
    return;
  }
  loading.value = true;
  try {
    const mStickerInsights = await findStickerInsights(stickerId.value);
    Object.assign(stickerInsights, mStickerInsights ?? {});
  } catch (error) {
    console.error('Error fetching sticker insights:', error);
  } finally {
    loading.value = false;
  }
}

async function getWinnersList() {
  if (item.value?.campaignType !== 'Sweepstakes' || !item.value?.id) {
    winners.value = [];
    return;
  }
  try {
    const response = await getWinners(item.value.id);
    winners.value = response ?? [];
  } catch (error) {
    console.error('Error fetching winners:', error);
  }
}

async function loadInsightsPanel() {
  await getStickerInsights();
  await getWinnersList();
}

onMounted(loadInsightsPanel);

watch(stickerId, (id, prev) => {
  if (id && id !== prev) {
    loadInsightsPanel();
  }
});
</script>

<template>
  <div class="c-add-sticker__extra__type c-add-sticker__insights">
    <div v-if="loading" class="c-add-sticker__insights-loading">
      Loading insights...
    </div>
    <template v-else>
      <sticker-insights
        inline
        :sticker-insights="stickerInsights"
        :winners="winners"
      />
      <gift-a-sticker v-if="item.campaignType === 'Ticket'" :stickerId="stickerId" />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.c-add-sticker__insights-loading {
  font-size: 12px;
  color: #666;
}
</style>
